export default "__VITE_ASSET__DNlaGpYs__"